export { $portalUserValues, updatePortalUserValuesEvent } from './portal-user-values';
